export default __webpack_public_path__ + "static/media/promptPay5.ba199bd7.png";